let API_URL_val = '/api/';

// noinspection JSUnresolvedVariable,ES6ModulesDependencies
if (process.env.NODE_ENV === 'development') {
  // noinspection JSUnresolvedVariable,ES6ModulesDependencies
  API_URL_val = `http://localhost:${(process.env.BACK_PORT || 8053)}/api/`;
}

export const API_URL = API_URL_val;
